export const BACKEND_URL = 'https://hathi.xyz';
export const BACKEND_API_URL = `${BACKEND_URL}/api/`;